export const CONTRACT_FILTER_TYPES = [
  'sendToSign',
  'toBeSentToSign',
  'notCreated',
  'signByTempWorker',
  'signByCompany',
];

export const CONTRACT_FILTER_OPTIONS = [
  {
    type: 'sendToSign',
    name: 'Contrat en attente de signature',
    description: null,
  },
  {
    type: 'toBeSentToSign',
    name: 'À envoyer pour signature',
    description: null,
  },
  {
    type: 'notCreated',
    name: 'Contrat non généré',
    description: 'Profil de l\'intérimaire non complet',
  },
  {
    type: 'signByTempWorker',
    name: 'Signé par l\'intérimaire',
    description: null,
  },
  {
    type: 'signByCompany',
    name: 'Signé par l\'entreprise',
    description: null,
  },
];

export const parseContractSearchParam = (contractParam) => {
  if (!contractParam) return [];
  return contractParam
    .split(',')
    .filter((type) => CONTRACT_FILTER_TYPES.includes(type))
    .slice(0, 1);
};

export const migrateSavedContractSearch = (saved = {}) => {
  if (Array.isArray(saved.contractSearch)) {
    return saved.contractSearch
      .filter((type) => CONTRACT_FILTER_TYPES.includes(type))
      .slice(0, 1);
  }

  if (Array.isArray(saved.typeContract)) {
    return saved.typeContract
      .filter((type) => CONTRACT_FILTER_TYPES.includes(type))
      .slice(0, 1);
  }

  return [];
};
